import EventDispatcher from '../_app/cuchillo/core/EventDispatcher';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import { Maths } from '../_app/cuchillo/utils/Maths';
import CircleVisor from '../layout/CircleVisor';

const VirtualScroll = require('../_app/vendor/VirtualScroll');

export default class ProgressScroller {
    static AXIS_X = 'X';
    static AXIS_Y = 'Y';

    scroller;
    direction = 1;

    position = 0;
    target = 0;
    speed = 0;
    size = 0;
    options;
    progress = 0;
    timerEnd = 0;
    isScrolling = false;

    _container;
    _enabled = false;
    _isShow = false;
    _axis = 'y';

    get enabled() { return this._enabled; }
    set enabled(__isEnabled) {
        if (this._enabled !== __isEnabled) {
            this._enabled = __isEnabled;
            if (this.scroller) {
                __isEnabled
                    ? this.scroller.on(this._call)
                    : this.scroller.off(this._call);
            }
        }
    }

    constructor(__axis, opts = {}) {
        this._container = opts.container || document.body;

        this.onStartScroll = null;
        this.onEndScroll = null;
               
        this.options = {
            axis: __axis || 'Y',
            smooth: opts.smooth || false,
            easing: opts.easing || 0.07,
            multiplicator: opts.multiplicator || .5,
            inverted: opts.inverted || false,
            hasVirtuaScroll: opts.hasVirtuaScroll !== false,
            hasInteraction: opts.hasInteraction,
            minSpeed: opts.minSpeed || 0,
            size: opts.size || 5
        };

        if (this.options.hasVirtuaScroll) {
            this.scroller = new VirtualScroll({
                mouseMultiplier: navigator.platform.indexOf('Win') > -1 ? 1 : 0.5,
                firefoxMultiplier: 50,
                touchMultiplier: 3.5,
                passive: true
            });
            this._call = (e) => { this.check(e); };
        }

        if (this.options.hasInteraction) {
            this._interaction = new MrInteraction(this._container, {
                drag: true,
                axis: 'x',
                dragCheckTime: .05,
                onMove: (n) => {
                    this.options.onMove?.();
                    this.move(n);
                },
                onDragStart: () => this.options.onDragStart?.(),
                onDragEnd: () => this.options.onDragEnd?.()
            });
        }
    }

    move(n) {
        this.check({ deltaY: n });
    }

    start() {
        this.enabled = true;
    }

    hide() {
        this.enabled = false;
    }

    goto(__n) {
        this.target = this.size * __n;
    }

    check(e, __direct) {
        clearTimeout(this.timerEnd);
        this.timerEnd = setTimeout(() => this.endScroll(), 200);

        this.startScroll();

        if (__direct) e = { deltaY: __direct };
        const d = Maths.precission(e.deltaY * this.options.multiplicator, 2);

        if (this.options.inverted) {
            this.target -= d;
            this.direction = e.deltaY >= 0 ? 1 : -1;
        } else {
            this.target += d;
            this.direction = e.deltaY < 0 ? 1 : -1;
        }

        this.checkHook(e);        
    }

    startScroll() {
        if (this.isScrolling) return;
        this.isScrolling = true;
        this.onStartScroll?.();
    }

    endScroll() {
        if (!this.isScrolling) return;
        this.isScrolling = false;
        this.onEndScroll?.();
    }

    checkHook() {}

    loop(__force = false) {
        this.target = this.target - this.options.minSpeed;
        if (Maths.precission(this.target) !== Maths.precission(this.position) || __force) {
            this.calcSpeed();
        } else {
            this.speed = 0;
        }
    }

    resize() {
        this.size = this.options == ProgressScroller.AXIS_Y
            ? Metrics.HEIGHT * this.options.size
            : Metrics.WIDTH * this.options.size;
    }

    calcSpeed() {
        this.speed = Maths.precission((this.target - this.position) * this.options.easing);
        if (this.speed === 0) this.position = this.target;
        else this.position += this.speed;     
        this.progress = 1 - (this.position % this.size + this.size) % this.size / this.size;
    }

    dispose() {
        this.enabled = false;
        this.scroller?.destroy();
        this._interaction?.dispose();
    }
}
